import { useState, useEffect } from "react";

import Header from "../Header";
import Banner from "../Banner";
import GlobalMenu from "../GlobalMenu";
import Footer from "../Footer";
import { Ads, StickyAds } from "../ads/Ads";
import CandidateBanner from "./parts/CandidateBanner";
import CandidateDetails from "./parts/CandidateDetails";
import CandidateInfoSection from "./parts/CandidateInfoSection";
import CandidateTestimonialSection from "./parts/CandidateTestimonialSection";
import styles from "../../styles/homepage/Home.module.scss";

const basePath = process.env.SITE_URL;
const CandidatePage = ({ contestName, data, particulars, candidates, url }) => {
  const [gaffesItems, setGaffesItems] = useState([]);
  const [questionsItems, setQuestionsItems] = useState([]);
  const [quotesItems, setQuotesItems] = useState([]);
  const [promisesItems, setPromisesItems] = useState([]);
  const [stancesItems, setStancesItems] = useState([]);

  const candidateScope = data.candidacy_set[0].contest.scope;
  const candidatePageUrl = `${basePath}elections/2022/candidates/${data.wp_slug}`;
  const { promises, gaffes, stances, quotes, questions } = particulars;
  const highlightsControversies = [];

  const comparison = (a, b) => {
    if (a.position < b.position) {
      return -1;
    }
    if (a.position > b.position) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    // Testimonials Sections
    setGaffesItems(
      (gaffes || []).map((gaffe) => ({
        ...gaffe,
        quote:
          gaffe.quote.toString().charAt(0) === '"' ||
          gaffe.quote.toString().charAt(0) === "“"
            ? gaffe.quote.toString().substring(1)
            : gaffe.quote.toString(),
        context: gaffe.context.toString(),
        source: gaffe.source,
      }))
    );
    setQuotesItems(
      (quotes || []).sort(comparison).map((item) => ({
        person: item.speaker.name,
        title: item.speaker.designation,
        message:
          item.quote.toString().charAt(0) === '"' ||
          item.quote.toString().charAt(0) === "“"
            ? item.quote.toString().substring(1)
            : item.quote,
        thumbnail: item.speaker.thumbnail,
      }))
    );

    // Details Sections
    setQuestionsItems(
      (questions || [])
        .map((item) => ({
          label: item.question,
          content: [
            {
              title: item.question,
              body: item.answer,
              urls: [item.primary_link, item.alternate_link].filter(
                (m) => m != null || m != undefined
              ),
            },
          ],
        }))
        .filter((item) => item)
    );
    setPromisesItems(
      (promises || []).map((promise) => {
        return {
          label: promise.issue,
          content: [
            {
              header: {
                title: `On ${promise.issue}`,
                body: promise.description,
              },
              details: {
                title: `What ${
                  data.alternate_name || data.first_name
                } is Saying`,
                body: promise.quote ? `<em>${promise.quote}</em>` : undefined,
              },
              context: {
                title: "Context",
                body: promise.context,
              },
              source: promise.source,
            },
          ],
        };
      })
    );
    const newStancesItems = [];
    stances.forEach((stance) => {
      const parentStanceIndex = newStancesItems.findIndex(
        (existingStance) => existingStance.label === stance.issue.parentIssue
      );
      const content = {
        label: stance.issue.name,
        content: [
          {
            positionStrength: stance.position_strength,
            header: {
              title: `${stance.issue.name}`,
              body: stance.quote,
            },
            details: {
              title: "",
              body: stance.explanation,
            },
            context: {
              title: "",
              body: stance.context,
            },
          },
        ],
      };
      if (parentStanceIndex === -1) {
        newStancesItems.push({
          label: stance.issue.parentIssue,
          content: [content],
        });
      } else {
        newStancesItems[parentStanceIndex].content.push(content);
      }
    });
    setStancesItems(newStancesItems);
  }, [
    gaffes,
    quotes,
    questions,
    promises,
    stances,
    data.alternate_name,
    data.first_name,
  ]);

  return (
    <div className={styles.container}>
      <Header />
      <Banner />
      <GlobalMenu candidateScope={candidateScope} />

      <CandidateBanner data={data} url={url} />
      <Ads
        deviceType="mobile"
        id="ad-candidate-billboard-mobile"
        adType="billboard"
        pageType="elec_profile_page"
        contestName={contestName}
      />
      <Ads
        deviceType="desktop"
        id="ad-candidate-billboard-desktop"
        adType="billboard"
        pageType="elec_profile_page"
        contestName={contestName}
      />
      <CandidateDetails
        data={data}
        url={url}
        contestName={contestName}
        candidates={candidates}
      />
      <Ads
        deviceType="mobile"
        id="ad-candidate-leaderboard1-mobile"
        adType="leaderboard1"
        pageType="elec_profile_page"
        contestName={contestName}
      />
      <Ads
        deviceType="desktop"
        id="ad-candidate-leaderboard1-desktop"
        adType="leaderboard1"
        pageType="elec_profile_page"
        contestName={contestName}
      />
      <CandidateInfoSection
        data={{ ...data, items: questionsItems || [] }}
        headline={`Top Questions About ${
          data.alternate_name || data.first_name
        } ${data.last_name}${
          data.last_name.split("").pop().toLowerCase() === "s" ? "'" : "'s"
        } Candidacy`}
        profileScoopPosition={"bottom"}
        type={"topQuestions"}
        anchor={"top-questions"}
        url={candidatePageUrl}
      />
      <CandidateInfoSection
        data={{ ...data, items: promisesItems || [] }}
        headline={`${data.alternate_name || data.first_name}${
          (data.alternate_name || data.first_name)
            .split("")
            .pop()
            .toLowerCase() === "s"
            ? "'"
            : "'s"
        } Promises as a Politician`}
        type={"promises"}
        anchor={"promises"}
        url={candidatePageUrl}
        contestName={contestName}
        candidacyId={data.candidacy_set[0].id}
      />
      <CandidateInfoSection
        data={{ ...data, items: highlightsControversies || [] }}
        headline={"Political Highlights & Controversies"}
        profileScoopPosition={"top"}
        type={"highlightsControversies"}
        anchor={"highlights-and-controversies"}
        url={candidatePageUrl}
      />
      <CandidateTestimonialSection
        data={{ ...data, gaffes: gaffesItems || [] }}
        headline={`${data.alternate_name || data.first_name} ${data.last_name}${
          data.last_name.split("").pop().toLowerCase() === "s" ? "'" : "'s"
        } Gaffes and Blunders`}
        type={"gaffesAndBlunders"}
        anchor={"gaffes-and-blunders"}
        url={candidatePageUrl}
      />
      <CandidateInfoSection
        data={{ ...data, items: stancesItems || [] }}
        headline={`${data.alternate_name || data.first_name} ${data.last_name}${
          data.last_name.split("").pop().toLowerCase() === "s" ? "'" : "'s"
        } Stances on Key Issues`}
        type={"stances"}
        anchor={"stances"}
        url={candidatePageUrl}
        contestName={contestName}
        candidacyId={data.candidacy_set[0].id}
      />
      <CandidateTestimonialSection
        data={{ ...data, quotes: quotesItems || [] }}
        headline={`What People Are Saying About ${
          data.alternate_name || data.first_name
        } ${data.last_name}`}
        type={"quotes"}
        anchor={"what-people-are-saying"}
        url={candidatePageUrl}
      />
      <StickyAds
        id="ad-candidate-national-sticky-desktop"
        deviceType="desktop"
        pageType="elec_profile_page"
        contestName={contestName}
      />
      <StickyAds
        id="ad-candidate-national-sticky-mobile"
        deviceType="mobile"
        pageType="elec_profile_page"
        contestName={contestName}
      />

      <Footer />
    </div>
  );
};

export default CandidatePage;
